import { ProductHit } from '@app-types/product-hit.types'
import { ProductSearchColor, ProductSearchHit } from '@app-domains/meilisearch/types/product-search.types'

function mapImage(
    image?: { url?: string | null; alt?: string | null } | null,
): ProductHit['primaryImage'] | undefined {
    if (! image?.url) {
        return undefined
    }

    return {
        url: image.url,
        alt: image.alt ?? '',
        type: '',
        subType: '',
        index: 0,
    }
}

function mapColor(color: string | ProductSearchColor): ProductHit['colors'][number] {
    if (typeof color === 'string') {
        return { name: color, presentation: '' }
    }

    return {
        name: color.name,
        presentation: color.presentation ?? '',
    }
}

export function mapSearchHitToProductHit(hit: ProductSearchHit): ProductHit {
    return {
        objectID: hit.objectID ?? hit.ean,
        ean: hit.ean,
        id: 0,
        slug: hit.slug ?? '',
        title: hit.title ?? '',
        shortDescription: hit.shortDescription ?? '',
        description: hit.shortDescription ?? '',
        brand: hit.brand ?? '',
        subBrand: hit.subBrand ?? '',
        range: hit.range ?? '',
        codeLocal: hit.codeLocal ?? '',
        status: hit.status ?? '',
        statusOriginal: hit.statusOriginal ?? '',
        categories: hit.categories ?? [],
        categoriesFull: [],
        categoryHierarchy: { lvl0: [], lvl1: [] },
        parentCategory: '',
        parentCategoryFull: { name: '', slug: '' },
        materials: hit.materials ?? [],
        subMaterials: hit.subMaterials ?? [],
        colors: (hit.colors ?? []).map(mapColor),
        subColors: (hit.subColors ?? []).map((name) => ({
            name,
            presentation: '',
        })),
        dimensions: {
            width: hit.dimensions?.width ?? 0,
            height: hit.dimensions?.height ?? 0,
            length: hit.dimensions?.length ?? 0,
            diameter: hit.dimensions?.diameter ?? 0,
            weight: hit.dimensions?.weight ?? 0,
        },
        primaryImage: mapImage(hit.primaryImage),
        ambianceImage: mapImage(hit.ambianceImage),
        wideImage: mapImage(hit.wideImage),
        suggestedRetailPriceNlInCents: hit.suggestedRetailPriceNlInCents ?? 0,
        suggestedRetailPriceIseInCents: hit.suggestedRetailPriceIseInCents ?? 0,
        suggestedRetailPriceNlInFloat: hit.suggestedRetailPriceNlInFloat ?? 0,
        suggestedRetailPriceIseInFloat: hit.suggestedRetailPriceIseInFloat ?? 0,
        suggestedStandardRetailPriceNlInCents: hit.suggestedStandardRetailPriceNlInCents ?? 0,
        suggestedStandardRetailPriceIseInCents: hit.suggestedStandardRetailPriceIseInCents ?? 0,
        suggestedStandardRetailPriceNlInFloat: hit.suggestedStandardRetailPriceNlInFloat ?? 0,
        suggestedStandardRetailPriceIseInFloat: hit.suggestedStandardRetailPriceIseInFloat ?? 0,
        deliveryTimeInfo: hit.deliveryTimeInfo ?? '',
        deliveryTimeInWeeks: hit.deliveryTimeInWeeks ?? null,
        orderStep: hit.orderStep ?? 0,
        numberOfIndividuals: hit.numberOfIndividuals ?? 0,
        seatingComfort: hit.seatingComfort ?? null,
        shape: hit.shape ?? null,
        pattern: hit.pattern ?? null,
        isNew: hit.isNew ?? false,
        isSale: hit.isSale ?? false,
        isFsc: hit.isFsc ?? false,
        is3DModelAvailable: hit.is3DModelAvailable ?? false,
        isAssemblyRequired: hit.isAssemblyRequired ?? false,
        assortment: '',
        country: '',
        createdAt: '',
        updatedAt: '',
        distinct: hit.ean,
        group: '',
        themes: [],
        type: 'product',
        filters: {
            brands: { name: hit.brand ?? '', code: '' },
            createdAt: 0,
            exclusivities: { label: '', code: '' },
            groups: { name: '', code: '' },
            isNew: hit.isNew ?? false,
            notAllowedInCountries: [],
            onlineActivationDate: 0,
        },
    }
}
